"use client";

import { signIn } from "next-auth/react";
import { useT } from "@/lib/i18n/provider";
import { useState } from "react";
import { Loader2 } from "lucide-react";

/**
 * Botões sociais das telas de AUTH (login e cadastro) — Google + Facebook (sem TikTok,
 * conforme handoffs), com ícones nas cores de marca. Compartilhado; não altera o
 * `OAuthButtons` legado (mantido só para o seu teste).
 */

function GoogleMark() {
    return (
        <svg className="h-[19px] w-[19px] shrink-0" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="#4285F4" d="M23.52 12.27c0-.85-.08-1.67-.22-2.45H12v4.64h6.46a5.52 5.52 0 0 1-2.4 3.62v3h3.87c2.27-2.09 3.58-5.17 3.58-8.81z" />
            <path fill="#34A853" d="M12 24c3.24 0 5.96-1.08 7.94-2.91l-3.87-3c-1.08.72-2.45 1.15-4.07 1.15-3.13 0-5.78-2.11-6.73-4.96H1.28v3.09A12 12 0 0 0 12 24z" />
            <path fill="#FBBC05" d="M5.27 14.28a7.2 7.2 0 0 1 0-4.56V6.63H1.28a12 12 0 0 0 0 10.74z" />
            <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42A11.98 11.98 0 0 0 12 0 12 12 0 0 0 1.28 6.63l3.99 3.09C6.22 6.86 8.87 4.75 12 4.75z" />
        </svg>
    );
}

function FacebookMark() {
    return (
        <svg className="h-[19px] w-[19px] shrink-0" viewBox="0 0 24 24" fill="#1877F2" aria-hidden="true">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
        </svg>
    );
}

export function AuthSocialButtons() {
    const t = useT().login;
    const [loading, setLoading] = useState<string | null>(null);

    const handle = async (provider: "google" | "facebook") => {
        try {
            setLoading(provider);
            await signIn(provider, { callbackUrl: "/dashboard", redirect: true });
        } catch (error) {
            console.error(`Erro no login com ${provider}:`, error);
            setLoading(null);
        }
    };

    const base =
        "flex w-full items-center justify-center gap-[11px] min-h-[44px] h-[46px] rounded-[8px] " +
        "bg-card border border-border text-foreground text-[14px] font-semibold " +
        "hover:border-accent hover:text-accent active:translate-y-px " +
        "transition-colors duration-150 disabled:opacity-60 disabled:cursor-not-allowed";

    return (
        <div className="flex flex-col gap-[10px]">
            <button type="button" className={base} onClick={() => handle("google")} disabled={loading !== null}>
                {loading === "google" ? <Loader2 className="h-[18px] w-[18px] animate-spin" /> : <GoogleMark />}
                {t.signInGoogle}
            </button>
            <button type="button" className={base} onClick={() => handle("facebook")} disabled={loading !== null}>
                {loading === "facebook" ? <Loader2 className="h-[18px] w-[18px] animate-spin" /> : <FacebookMark />}
                {t.signInFacebook}
            </button>
        </div>
    );
}
